import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import './LeaveRequestSearchStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_leave_types_with_pagination } from '../../../../config/SettingsApis/leaveTypeApis';
import { leaveStatusOptions } from '../../../../utils/constants';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';

function LeaveRequestSearch({ searchFilter, tableTitle, on_change_value, on_page_count_update }) {

    const [leaveTypes, setLeaveTypes] = useState([]);

    const fetchLeaveRequests = async () => {
        try {
            const params = {
                status: 1
            }
            const response = await get_leave_types_with_pagination(params);
            if (response?.status === "success") {

                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Name,
                    value: item?.LTL_Id
                }));
                setLeaveTypes(transformedData || []);

            } else {
                setLeaveTypes([]);
            }
        } catch (error) {
            setLeaveTypes([]);
            console.log(error);
        }
    };

    useEffect(() => {
        fetchLeaveRequests()
    }, [])

    const formik = useFormik({
        initialValues: {
            name: '',
            // phone: '',
            leaveType: '',
            start_date: '',
            end_date: '',
            status: "" //-1
        },
        // onSubmit: (values) => {
        //     searchFilter(values);
        // },
    });

    const resetFilter = () => {
        formik.resetForm();
        on_change_value(1)
        on_page_count_update(25)
        searchFilter({
            name: '',
            // phone: '',
            leaveType: '',
            start_date: '',
            end_date: '',
            status: '' //-1
        });
    };
    const breadcrumbs = ["Leave", tableTitle];

    return (
        <div className="leave-search-filter-container">
            <div className="leave-search-filter-sub-container">
                <div className="leave-search-filter-header">

                    <div className="leave-search-left">
                        <div className="project-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="name"
                                    placeholder="Enter name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                            </Grid>
                       
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="leaveType"
                                    placeholder="Select Leave"
                                    options={leaveTypes}
                                    value={leaveTypes.find((worksite) => worksite.value === formik.values.leaveType) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("leaveType", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="180px"
                                />

                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="start_date"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("start_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="end_date"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("end_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.end_date, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")} // Set minimum date
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={leaveStatusOptions}
                                    value={
                                        leaveStatusOptions?.find(option => option?.value === formik?.values?.status) ||
                                        leaveStatusOptions?.find(option => option?.value === '') //-1
                                    }
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : '');
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="180px"
                                />
                            </Grid>
                        </div>
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default LeaveRequestSearch;
